import { gql } from 'apollo-angular';
import { logItemFragment } from './log.fragments';

export const GoalCardLogsQuery = gql`
  query GoalCardLogsQuery($goalCardIds: [ID!]) {
    cardLogs(goalCardIds: $goalCardIds) {
      nodes {
        ...LogItemFragment
      }
    }
  }
  ${logItemFragment}
`;

export const EventCardLogsQuery = gql`
  query EventCardLogsQuery($eventCardIds: [ID!]) {
    cardLogs(eventCardIds: $eventCardIds) {
      nodes {
        ...LogItemFragment
      }
    }
  }
  ${logItemFragment}
`;
